import {
  openMap,
  closeMap,
  openPanorama,
  closePanorama,
  setActiveInfrastructureCategory,
  setPanoramaError,
  setZoom,
  setInfrastructureCategories,
  setActiveInfrastructureItem,
  activeRouteMode,
  deactiveRouteMode,
  openRouteSearchModal,
  closeRouteSearchModal,
  setLocation,
  setRouteFrom,
  setRouteTo,
  setRouteInfo,
  setRoutingMode,
  resetRoute,
  setRouteBuildingLoading,
  setRouteBuildingSucceed,
  setRouteBuildingFailed,
  setCenter,
} from './actions';

export enum EMapActions {
  OpenMap = 'MAP/OPEN_MAP',
  CloseMap = 'MAP/CLOSE_MAP',
  OpenPanorama = 'MAP/OPEN_PANORAMA',
  ClosePanorama = 'MAP/CLOSE_PANORAMA',
  SetActiveInfrastructureCategory = 'MAP/INFRASTRUCTURE/SET_ACTIVE_CATEGORY',
  SetZoom = 'MAP/SET_ZOOM',
  SetPanoramaError = 'MAP/SET_PANORAMA_ERROR',
  SetInfrastructureCategories = 'MAP/INFRASTRUCTURE/SET_CATEGORIES',
  SetActiveInfrastructureItem = 'MAP/INFRASTRUCTURE/SET_ACTIVE_ITEM',
  ActiveRouteMode = 'MAP/ACTIVE_ROUTE_MODE',
  DeactiveRouteMode = 'MAP/DEACTIVE_ROUTE_MODE',
  OpenRouteSearchModal = 'MAP/OPEN_ROUTE_SEARCH_MODAL',
  CloseRouteSearchModal = 'MAP/CLOSE_ROUTE_SEARCH_MODAL',
  SetLocation = 'MAP/SET_LOCATION',
  SetRouteFrom = 'MAP/SET_ROUTE_FROM',
  SetRouteTo = 'MAP/SET_ROUTE_TO',
  SetRouteBuildingLoading = 'MAP/SET_ROUTE_BUILDING_LOADING',
  SetRouteBuildingSucceed = 'MAP/SET_ROUTE_BUILDING_SUCCEED',
  SetRouteBuildingFailed = 'MAP/SET_ROUTE_BUILDING_FAILED',
  SetRouteInfo = 'MAP/SET_ROUTE_INFO',
  ResetRouteInfo = 'MAP/RESET_ROUTE_INFO',
  SetRoutingMode = 'MAP/SET_ROUTING_MODE',
  ResetRoute = 'MAP/RESET_ROUTE',
  SetCenter = 'MAP/SET_CENTER',
}

export type TMapAction =
  | ReturnType<typeof openMap>
  | ReturnType<typeof closeMap>
  | ReturnType<typeof openPanorama>
  | ReturnType<typeof closePanorama>
  | ReturnType<typeof setActiveInfrastructureCategory>
  | ReturnType<typeof setPanoramaError>
  | ReturnType<typeof setZoom>
  | ReturnType<typeof setInfrastructureCategories>
  | ReturnType<typeof setActiveInfrastructureItem>
  | ReturnType<typeof activeRouteMode>
  | ReturnType<typeof deactiveRouteMode>
  | ReturnType<typeof openRouteSearchModal>
  | ReturnType<typeof closeRouteSearchModal>
  | ReturnType<typeof setLocation>
  | ReturnType<typeof setRouteFrom>
  | ReturnType<typeof setRouteTo>
  | ReturnType<typeof setRouteBuildingLoading>
  | ReturnType<typeof setRouteBuildingSucceed>
  | ReturnType<typeof setRouteBuildingFailed>
  | ReturnType<typeof setRouteInfo>
  | ReturnType<typeof setRoutingMode>
  | ReturnType<typeof resetRoute>
  | ReturnType<typeof setCenter>;
